import type { AppDispatch } from '../../store';
import {
  selectEquipmentPort,
  selectInstance,
  setDrawActive,
  setPortEditInstance,
} from '../equipment/equipmentSlice';
import {
  selectLayoutPort,
  selectTrackNode,
  setStockerPortEdit,
} from '../layout/layoutSlice';
import { clearSelection } from '../selection/selectionSlice';
import { setSimulationPanelOpen } from './uiSlice';

/**
 * Switch to Simulator in pan mode and tear down any in-progress editor
 * interaction: drawing tools, track-node placement, stop placement, port-edit
 * handles, and selection/resize chrome.
 */
export const enterSimulationMode = () => (dispatch: AppDispatch) => {
  dispatch(clearSelection());
  dispatch(selectInstance(null));
  dispatch(selectEquipmentPort(null));
  dispatch(setPortEditInstance(null));
  dispatch(setDrawActive(false));
  dispatch(setStockerPortEdit(null));
  dispatch(selectLayoutPort(null));
  dispatch(selectTrackNode(null));
  // Opens the panel and deactivates UI tools (Point Draw, track-node place, …).
  dispatch(setSimulationPanelOpen(true));
};
